/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	(function () {
	
	  /*$('.navigation-link').attr('href', generateLinkForNavigation(49.202416, 16.626341));*/
	  window.generateLinkForNavigation = generateLinkForNavigation;
	
	  /**
	   * [generateLinkForNavigation Funkce generujici odkaz pro navigovani, otevre mapu se souradnicemi v novem okne.]
	   * @param  {[type]} lat [lat souradnice]
	   * @param  {[type]} lot [lot souradnice]
	   * @return {[type]}     [description]
	   */
	  function generateLinkForNavigation(lat, lot) {
	    var ua = navigator.userAgent.toLowerCase();
	    var plat = navigator.platform;
	    var protocol = '';
	    var href = '?daddr=' + lat + ',' + lot + '&amp;ll="';
	
	    //$.browser.device = ua.match(/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera/i) ? ua.match(/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera/i)[0] : false;
	    var dev = ua.match(/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera/i) ? ua.match(/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera/i)[0] : false;
	
	    if (dev) {
	      switch (dev) {
	        case 'iphone':
	        case 'ipad':
	        case 'ipod':
	          var ver = iOSversion(plat) || [0];
	
	          if (ver[0] >= 6) protocol = 'maps://';else protocol = 'http://maps.google.com/maps';
	          break;
	
	        case 'android':
	        default:
	          protocol = 'http://maps.google.com/maps';
	          break;
	      }
	    } else {
	      protocol = 'http://maps.google.com/maps';
	    }
	    //a.attr('href', protocol + href);
	    var link = protocol + href;
	    window.open(link);
	  }
	
	  /**
	   * [iOSversion Zjisteni iOS zarizeni.]
	   * @param  {[type]} plat [platforma]
	   * @return {[type]}      [description]
	   */
	  function iOSversion(plat) {
	    if (/iP(hone|od|ad)/.test(plat)) {
	      // supports iOS 2.0 and later: <http://bit.ly/TJjs1V>
	      var v = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
	      return [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)];
	    }
	  }
	})();

/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** navigation-link.js
 **/